import { Prismic } from './Prismic';

export function isEmptyText(el?: Prismic.RichText | null) {
  if (!el) return true;

  const text = Prismic.text(el);
  return !text || text.trim() === '';
}
